import css from './CheckboxInput.module.css';

import { useState } from 'react';
import Visibility from '../Visibility/Visibility';
import StatusText from '../StatusText/StatusText';

type CheckboxInputProps = {
  label?: string;
  name: string;
  value: boolean;
  valid: boolean;
  enabled?: boolean;
  statusText?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
};

const CheckboxInput = ({
  label,
  name,
  value,
  valid,
  enabled,
  statusText,
  onChange,
}: CheckboxInputProps) => {
  const [pure, setPure] = useState<boolean>(true);
  const showError = !valid && !pure;

  const inputClass = showError ? css.error : undefined;

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPure(false);

    if (onChange !== undefined) {
      onChange(event);
    }
  };

  if (statusText === undefined) {
    statusText = 'This field is required';
  }

  return (
    <div className={css.checkboxInput}>
      <span>
        <input
          type='checkbox'
          id={name}
          name={name}
          checked={value}
          onChange={onChangeHandler}
          className={inputClass}
          disabled={enabled !== undefined && !enabled}
        />
        <label htmlFor={name}>{label}</label>
      </span>
      <Visibility visible={showError}>
        <StatusText text={statusText} tiny={true} error={true} />
      </Visibility>
    </div>
  );
};

export default CheckboxInput;
